module.exports = [{
      plugin: require('C:/Users/matsp/projects/gatsby-starter-cv/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
